import { app as mongoDB } from "./app.js";
import * as Realm from "realm-web";
export async function fetchRoadmapForUpdate(roadmapID) {
  const user = mongoDB.currentUser;
  // TODO: Initialize a MongoDB Service Client
  const mongoClient = mongoDB.currentUser.mongoClient("mongodb-atlas");

  // TODO: Instantiate a collection handle for todo.items
  const roadmapCollection = mongoClient.db("Main").collection("roadmaps");

  if (roadmapID.length !== 24) {
    return new Promise(function (resolve, reject) {
      reject("not 24, something not right");
    });
  }

  if (Object.keys(user.customData).length === 0) {
    await mongoDB.currentUser.refreshCustomData();
  }
  if (
    mongoDB.currentUser.customData.createdRoadmaps.some(
      (roadmap) => roadmap.$oid === roadmapID
    )
  ) {
    const query = { _id: new Realm.BSON.ObjectId(roadmapID) };
    return roadmapCollection.findOne(query);
  } else {
    return new Promise(function (resolve, reject) {
      reject("permission denied");
    });
  }
}

export async function fetchRoadmap(roadmapID) {
  // fetching a normal roadmap
  // depending on if user starred it, return differnt information
  const user = mongoDB.currentUser;
  // TODO: Initialize a MongoDB Service Client
  const mongoClient = mongoDB.currentUser.mongoClient("mongodb-atlas");

  // TODO: Instantiate a collection handle for todo.items
  const roadmapCollection = mongoClient.db("Main").collection("roadmaps");

  if (roadmapID.length !== 24) {
    return new Promise(function (resolve, reject) {
      reject("not 24, something not right");
    });
  }
  if (
    Object.keys(user.customData).length === 0 &&
    user.loggedInProviderType !== "anon-user"
  ) {
    await mongoDB.currentUser.refreshCustomData();
  }
  const query = { _id: new Realm.BSON.ObjectId(roadmapID) };

  return roadmapCollection.findOne(query);
}

export async function fetchAllRoadmaps() {
  // TODO: Initialize a MongoDB Service Client
  const mongoClient = mongoDB.currentUser.mongoClient("mongodb-atlas");

  // TODO: Instantiate a collection handle for todo.items
  const roadmapCollection = mongoClient.db("Main").collection("roadmaps");
  return roadmapCollection.find({});
}

export async function fetchUser(userID) {
  // TODO: Initialize a MongoDB Service Client
  const mongoClient = mongoDB.currentUser.mongoClient("mongodb-atlas");

  // TODO: Instantiate a collection handle for todo.items
  const userCollection = mongoClient.db("Main").collection("users");
  return userCollection.findOne({ userId: userID });
}

export async function onTrackRoadmap(newTrackRoadmap) {
  // TODO: Initialize a MongoDB Service Client
  const mongoClient = mongoDB.currentUser.mongoClient("mongodb-atlas");

  // TODO: Instantiate a collection handle for todo.items
  const userCollection = mongoClient.db("Main").collection("users");
  const query = { userId: mongoDB.currentUser.id };
  const update = {
    $push: { starredRoadmaps: newTrackRoadmap },
  };
  const options = { returnNewDocument: true };

  return userCollection.findOneAndUpdate(query, update, options);
}

export async function onUntrackRoadmap(roadmapId) {
  // TODO: Initialize a MongoDB Service Client
  const mongoClient = mongoDB.currentUser.mongoClient("mongodb-atlas");

  // TODO: Instantiate a collection handle for todo.items
  const userCollection = mongoClient.db("Main").collection("users");
  console.log(roadmapId);
  const query = { userId: mongoDB.currentUser.id };
  const update = {
    $pull: { starredRoadmaps: { roadmapId: roadmapId } },
  };
  const options = { returnNewDocument: true };
  return userCollection.findOneAndUpdate(query, update, options);
}

export async function updateTrackingRoadmap({
  newNotes,
  newNoteLinks,
  roadmapId,
}) {
  // TODO: Initialize a MongoDB Service Client
  const mongoClient = mongoDB.currentUser.mongoClient("mongodb-atlas");

  // TODO: Instantiate a collection handle for todo.items
  const userCollection = mongoClient.db("Main").collection("users");
  console.log({ newNotes }, { newNoteLinks }, { roadmapId });

  // find the one staredRoadmap by matching roadmapId (objectID) in starredRoadmaps field of users
  // then, set the noteNodes & noteLinks array

  const query = {
    userId: mongoDB.currentUser.id,
    "starredRoadmaps.roadmapId": new Realm.BSON.ObjectId(roadmapId),
  };
  const update = {
    $set: {
      "starredRoadmaps.$.noteNodes": newNotes,
      "starredRoadmaps.$.noteLinks": newNoteLinks,
    },
  };
  const options = { returnNewDocument: true };
  userCollection
    .findOneAndUpdate(query, update, options)
    .then((uh) => {
      console.log(uh);
    })
    .catch((err) => {
      console.log(err);
    });
}

export async function updateClearItem({ roadmapId, nodeId, updateMode }) {
  console.log({ nodeId }, { roadmapId });
  // TODO: Initialize a MongoDB Service Client
  const mongoClient = mongoDB.currentUser.mongoClient("mongodb-atlas");

  // TODO: Instantiate a collection handle for todo.items
  const userCollection = mongoClient.db("Main").collection("users");

  // find the one staredRoadmap by matching roadmapId (objectID) in starredRoadmaps field of users
  // then, set the noteNodes & noteLinks array

  const query = {
    userId: mongoDB.currentUser.id,
    "starredRoadmaps.roadmapId": new Realm.BSON.ObjectId(roadmapId),
  };
  let update = {
    $addToSet: {
      "starredRoadmaps.$.completedNodesID": nodeId,
    },
  };
  if (updateMode === "pull") {
    update = {
      $pull: {
        "starredRoadmaps.$.completedNodesID": nodeId,
      },
    };
  }

  const options = { returnNewDocument: true };
  userCollection
    .findOneAndUpdate(query, update, options)
    .then((uh) => {
      console.log(uh);
    })
    .catch((err) => {
      console.log(err);
    });
}
